import { PRODUCT_KEYS } from "./products";

export const RIDER_DATA = {
  life: {
    title: "quote.riders.life_option",
    value: "Life",
    subtitle: "quote.riders.waives_off_future_premiums_in_case_of_death_terminal_illness",
    sectionName: "WOP",
  },
  ciad: {
    title: "quote.riders.critical_illness_and_accidental_disability_option",
    value: "Health",
    subtitle: "quote.riders.waives_off_future_premiums_in_case_of_15_critical_illnesses_accidental_disability",
    sectionName: "WOP",
  },
  lifeAndCiad: {
    title: "quote.riders.life_critical_illness_and_accidental_disability_option",
    value: "Life and Health",
    subtitle:
      "quote.riders.waives_off_future_premiums_in_case_of_death_terminal_illness_15_critical_illnesses_accidental_disability",
    sectionName: "WOP",
  },
  btbb: {
    title: "quote.riders.term_booster_benefit_rider_sup_14",
    subtitle:
      "quote.riders.your_nominee_will_get_additional_sum_assured_payout_in_the_event_of_death_or_terminal_illness_whichever_is_earlier_of_the_life_assured",
    sectionName: "BTBB",
  },
  adb: {
    title: "quote.riders.accidental_death_benefit_rider_sup_1",
    subtitle:
      "quote.riders.your_nominee_will_get_additional_coverage_in_case_of_an_unfortunate_event_due_to_an_accident",
    sectionName: "ADBY",
  },
  atpd: {
    title: "quote.riders.accidental_total_and_permanent_disability_rider_sup_2",
    subtitle:
      "quote.riders.your_nominee_will_get_additional_coverage_in_case_of_permanent_and_total_disability_due_to_an_accident",
    sectionName: "ACPD",
  },
};

export const RIDER_PRIORITY_MAP = {
  [PRODUCT_KEYS.SIGNATUREULIP]: [{ product: "btbb", priority: 1, sectionName: "BTBB", Percentage: 50 }],
  // [PRODUCT_KEYS.SIGNATURE_ASSURE]: [{ product: "adb", priority: 1, sectionName: "ADBY", Percentage: 100 }],

  [PRODUCT_KEYS.GIFTPRO]: [
    { product: "lifeAndCiad", priority: 1, sectionName: "WOP", Percentage: 0 },
    { product: "ciad", priority: 2, sectionName: "WOP", Percentage: 0 },
    { product: "life", priority: 3, sectionName: "WOP", Percentage: 0 },
  ],
  // [PRODUCT_KEYS.SMARTKID_ASSURE]: [{ product: "adb", priority: 1, sectionName: "ADBY", Percentage: 100 }],

  // { product: "lifeAndCiad", priority: 2, sectionName: "WOP", Percentage: 0 },
  // { product: "ciad", priority: 3, sectionName: "WOP", Percentage: 0 },
  // { product: "life", priority: 4, sectionName: "WOP", Percentage: 0 },
  // { product: "adb", priority: 5, sectionName: "ADBY", Percentage: 100 },
  // { product: "atpd", priority: 6, sectionName: "ACPD", Percentage: 0 },
};

export const RIDER_TYPES = {
  ADBY: "ADBY",
  WOP: "WOP",
  ACPD: "ACPD",
  BTBB: "BTBB",
};
